import React from 'react';
import _ from 'lodash';
import { Thumb } from '../Thumb';
import { roundCurrency } from '../../../Common/Helper';

const OrderItemSubscription = (props) => {
  const {
    separator = '',
    id = '',
    price = '',
    quantity = '',
    media = '',
    currency = '',
  } = props;

  return (
    <div>
      {id > 0 && separator}
      <div className='d-lg-flex justify-content-between'>
        <div className='col-auto px-0 d-flex flex-column align-items-center align-items-lg-start'>
          <Thumb media={_.get(media, '0')}/>
          <div className='my-2'></div>
        </div>
        <div className='col px-0 px-lg-3 justify-content-center justify-content-lg-start'>
          <Description {...props}/>
        </div>
        <div className='col-auto px-0 d-none d-lg-flex flex-column align-items-end'>
          <h4
            className='ProximaNova-Bold text-nowrap text-primary mb-0'>{`${currency} ${roundCurrency(price)}`}</h4>
          <p className='small'>Qty: {quantity}</p>
        </div>
      </div>
    </div>
  );
};

const Description = (props) => {
  const {
    name = '',
    description = '',
  } = props;

  return (
    <div className='d-flex flex-column justify-content-between'>
      <h4 className='ProximaNova-Bold text-center text-lg-left mb-2'>{name}</h4>
      <div dangerouslySetInnerHTML={{ __html: `${description}` }}/>
    </div>
  );
};

export default OrderItemSubscription;



// WEBPACK FOOTER //
// ./src/Account/Order/OrderItem/OrderItemSubscription.js